import { render, staticRenderFns } from "./LerpScroll.vue?vue&type=template&id=e3541340&lang=pug&"
import script from "./LerpScroll.vue?vue&type=script&lang=js&"
export * from "./LerpScroll.vue?vue&type=script&lang=js&"
import style0 from "./LerpScroll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports